<template>
    <section class="design-project-section"><slot /></section>
</template>

<script>
export default {};
</script>

<style>
.design-project-section:not([class*='pt-']) {
    padding-top: 35px;
}

.design-project-section:not([class*='pb-']) {
    padding-bottom: 35px;
}
</style>
